import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useMemo } from 'react';
import { ArticleDetailUtil } from 'shared/models';
import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';
import { CommonPageOGCard, EOGType, ICommonPageOGCardProps, IOGImage } from '@lemon8/web-app-shared/ssr';

export const ArticleOpenGraph = () => {
  const getOGImageMeta: () => IOGImage | null = () => {
    const article = useAtomValue($CurrentArticle);
    const imageMeta = useMemo(() => {
      if (!ArticleDetailUtil.isArticleAvailable(article)) {
        return null;
      }
      return ArticleDetailUtil.getCoverImage(article);
    }, []);
    return imageMeta?.url
      ? {
          url: imageMeta.shareCardCoverImage || imageMeta.url,
          width: imageMeta.width,
          height: imageMeta.height,
        }
      : null;
  };
  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: useAtomValue($PageLevelTraffic).canonicalUrl,
    ogTitle: useArticleTitle(),
    ogDescription: useArticleDescription(),
    ogMediaMetaInfo: getOGImageMeta(),
    // Temperately set all card as OG Article type
    ogType: EOGType.Article,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
